import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { useRouterSearchParams as useRouterSearchParameters } from "@/hooks/router";
import FollowersScreen from "@/screens/Relationships/FollowersScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  const username = useRouterSearchParameters("username");
  return <FollowersScreen {...props} username={username} />;
}

export default withSessionHandling(Page);
